import Vue from 'vue';

const mutations = {
  SET_TIME_ZONES(state, { timeZones }) {
    state.timeZones = timeZones;
  },

  SET_ROUTE_TIMEZONE(state, { route, timeZone }) {
    Vue.set(state.routes, route, timeZone);
  },
};

export default mutations;
